import states from '../../../../States';

export default {
	creditorType: {
		label: 'Is the creditor a person or a company?',
		options: ['A Company (Lienholder)', 'A Person (Loss Payee)'],
		required: true
	},
	creditorFirstName: {
		label: 'First Name',
		validate: (data) => data.creditorType === 0 || (data.creditorType  === 1 && data.creditorFirstName !== ''),
		required: true
	},
	creditorLastName: {
		label: 'Last Name',
		validate: (data) => data.creditorType === 0 || (data.creditorType  === 1 && data.creditorLastName !== ''),
		required: true
	},
	creditorBusinessName: {
		label: 'Business Name',
		validate: (data) => data.creditorType === 1 || (data.creditorType  === 0 && data.creditorBusinessName !== ''),
		required: true
	},
	creditorAddressHouseNumber: {
		label: 'Street #',
		required: true,
		validate: (data) => data.creditorAddressHouseNumber !== '' || data.creditorAddressPOBox !== '',
		type: 'number'
	},
	creditorAddressStreetName: {
		label: 'Street',
		required: true,
		validate: (data) => data.creditorAddressStreetName !== '' || data.creditorAddressPOBox !== ''
	},
	creditorAddressApartmentNumber: {
		label: 'Apartment #',
		validate: () => true,
		type: 'number'
	},
	creditorAddressPOBox: {
		label: 'P.O. Box',
		validate: (data) => data.creditorAddressPOBox !== '' || (data.creditorAddressHouseNumber !== '' && data.creditorAddressStreetName !== '')
	},
	creditorAddressZip: {
		label: 'Zip (5 digits)',
		required: true,
		minimumlength: 5,
		maximumlength: 5,
        numeric: true,
		validate: (data) => data.creditorAddressZip !== '' ,
		type: 'number'
	},
	creditorAddressCity: {
		label: 'City',
		required: true
	},
	creditorAddressStateId: {
		label: 'State',
		options: () => states.map((s) => s.name.toUpperCase()),
		base: 1,
		required: true
	}
};
